import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();
  
  return (
    <div className="flex items-center space-x-2 bg-white border-2 border-gray-200 rounded-lg px-2 py-1.5 shadow-sm">
      <button
        onClick={() => changeLanguage('en')}
        className={`text-2xl transition-all duration-200 hover:scale-110 ${
          language === 'en'
            ? 'opacity-100 scale-110 ring-2 ring-pink-500 rounded'
            : 'opacity-50 hover:opacity-75'
        }`}
        title="English"
      >
        🇬🇧
      </button>
      <div className="w-px h-6 bg-gray-300"></div>
      <button
        onClick={() => changeLanguage('lt')}
        className={`text-2xl transition-all duration-200 hover:scale-110 ${
          language === 'lt'
            ? 'opacity-100 scale-110 ring-2 ring-pink-500 rounded'
            : 'opacity-50 hover:opacity-75'
        }`}
        title="Lietuvių"
      >
        🇱🇹
      </button>
    </div>
  );
};
